
export default ()=>({
    beforeLocation(data) {
        if (!data.name.trim()) {
            return new Error('请填写菜单名称')
        }
    }
})